module.exports = __webpack_public_path__ + "img/thumbnail_Quokka_j_normal.79b5f85c.png";